module.exports = __webpack_public_path__ + "img/33_19.2cf7426c.png";